import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import "./veriSimpleNav.scss";

export interface IVeriPillNavLabel {
    label: string;
    count?: number;
    highlighted?: boolean;

    order?: number;
    icon?: string;
}

export interface IVeriPillNavDataLabel<T> extends IVeriPillNavLabel {
    data?: T;
}

@Component({
    selector: 'veri-simple-nav',
    template: require('./veriSimpleNav.html')
})
export class VeriSimpleNavComponent implements OnChanges, OnInit{
    @Input() labels: IVeriPillNavLabel[];
    @Output() onLabelClicked: EventEmitter<IVeriPillNavLabel> = new EventEmitter();

    constructor() { }

    ngOnInit() {
        this.labels.sort((a, b) => a.order - b.order);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.labels && this.labels.length > 0) {
            let hasHighlighted = false;
            this.labels.forEach(label => {
                hasHighlighted = hasHighlighted || label.highlighted;
            });

            if (!hasHighlighted) {
                this.labels[0].highlighted = true;
            }
        }
    }

    labelClicked(label: IVeriPillNavLabel) {
        this.labels.forEach(l => {
            l.highlighted = false;
        });

        label.highlighted = true;

        if (this.onLabelClicked) {
            this.onLabelClicked.emit(label);
        }
    }
}
//import * as angular from "angular";

//interface IVeriSimpleNavBindings {
//    labels: IVeriPillNavLabel[];

//    onLabelClicked: (args: { $label: IVeriPillNavLabel }) => void;
//}

//class VeriSimpleNavComponentController implements angular.IComponentController, IVeriSimpleNavBindings {

//    labels: IVeriPillNavLabel[];
//    onLabelClicked: (args: { $label: IVeriPillNavLabel }) => void;

//    static $inject = [];

//    constructor() {
//    }

//    $onChanges(onChangesObj: angular.IOnChangesObject) {
//        // Set first to be the default highlight
   
//    }


//}

//export class VeriSimpleNavComponent implements angular.IComponentOptions {
//    bindings: any;
//    controller: any;
//    template: string;

//    constructor() {
//        this.bindings = {
//            labels: "<",
//            onLabelClicked: "&"
//        };

//        this.controller = VeriSimpleNavComponentController;
//        this.template = require("./veriSimpleNav.html");
//    }
//}
